var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leftContent"},[_c('v-header',_vm._b({},'v-header',_vm.$attrs,false)),_c('v-tree')],1)}
var staticRenderFns = []

export { render, staticRenderFns }